import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TAccountProviderUser, TAccountProviderUserPayloadUpdate, TAccountProviderUserResponse, adaptAccountProviderUserFromResponse, adaptAccountProviderUserToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_PROVIDER_USER } from '../../backend-paths';


export const accountProviderUserUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ACCOUNT_PROVIDER_USER}/:id`,
	(payload: TAccountProviderUserPayloadUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ACCOUNT_PROVIDER_USER}/${id}`;
		const dataRequest = adaptAccountProviderUserToRequest(data);

		return HttpService.put<TAccountProviderUserResponse>(path, dataRequest).then(result => {
			return adaptAccountProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProviderUserUpdateSlice = createSlice({
	name: 'accountProviderUserUpdateSlice',
	initialState,
	reducers: {
		clearAccountProviderUserUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProviderUserUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProviderUserUpdateApi.fulfilled.type]: (state, action: PayloadAction<TAccountProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProviderUserUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProviderUserUpdateSelector = () => useAppSelector(state => state[accountProviderUserUpdateSlice.name]);

export const { clearAccountProviderUserUpdate } = accountProviderUserUpdateSlice.actions;
